<template>
  <div
    class="nav-header d-flex justify-content-between align-items-center py-1 ps-3 pe-1"
  >
    <h1 class="add_on-activation-title">
      {{ t("ADD_ONS.SERVICE_ACTIVATION") }}
    </h1>
    <span
      class="material-symbols-outlined p-2_5 close-view"
      @click="handleClose"
      >close</span
    >
  </div>
  <div>
    <div class="mx-4 my-3">
      <AddOn v-if="addOnDetails" :addOnDetails="addOnDetails" />
    </div>
    <div class="spacer"></div>
    <div class="justify-self-end">
      <div class="mx-3 my-2_5 add_on-cta-btn-container">
        <div v-if="addOnDetails">
          <p class="add_on-terms-and-conditions-text px-2">
            {{ t("ADD_ONS.TERMS_AND_CONDITIONS_TEXT") }}
          </p>
        </div>
        <Button
          id="btn-submit"
          class="fw-bolder add_on-confirmation-btn"
          @click="handleActivateAddOn"
          :disabled="isActivating || !addOnDetails"
        >
          {{
            isActivating
              ? t("ADD_ONS.ACTIVATING")
              : t("ADD_ONS.ACTIVATE_SERVICE")
          }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import AddOn from "@/apps/credit-line/components/AddOn.vue";
import Button from "@/apps/credit-line/components/Button.vue";
import { IAddOnDetailsResponse } from "@/apps/credit-line/types/responses";
import { useI18n } from "@/apps/credit-line/composables/useI18n";

interface Props {
  addOnDetails: IAddOnDetailsResponse | null;
  isActivating: boolean;
  onActivateAddOn: () => void;
  onClose: () => void;
}

const props = defineProps<Props>();

const { t } = useI18n();

const handleActivateAddOn = () => {
  if (props.onActivateAddOn) {
    props.onActivateAddOn();
  }
};

const handleClose = () => {
  if (props.onClose) {
    props.onClose();
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/scss/_spacing-utils.scss";

.nav-header {
  border-bottom: 1px solid #eee;
}

.add_on-terms-and-conditions-text {
  text-align: center;
  line-height: 1rem;
  font-family: Inter;
  color: #8b8b8b;
  letter-spacing: 0px;
  font-weight: 500;
  font-size: 0.625rem;
  height: 2.938rem;
  display: flex;
  align-items: center;
}

.add_on-subtitle {
  font-family: Inter;
  font-size: 0.875rem;
  line-height: 1rem;
  font-weight: 500;
  color: #8b8b8b;
  margin-bottom: 0.5rem;
}
.add_on-title {
  line-height: 22px;
  font-size: 1.25rem;
  font-weight: 600;
  font-family: Inter;
  font-family: Inter, sans-serif;
  color: black;
}
.add_on-activation-title {
  font-size: 1rem;
  font-weight: 600;
  font-family: Inter, sans-serif;
  line-height: 1.5rem;
  margin-bottom: 0;
  color: black;
}
.spacer {
  flex-grow: 1;
}

.add_on-confirmation-btn {
  border-radius: 0.313rem;
  background-color: #007c3b;
}
.add_on-cta-btn-container {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
